export const PROJECT_EVENTS_FAB_BOTTOM = { xs: 16, sm: 24 };
export const PROJECT_CHAT_FAB_BOTTOM = { xs: 144, sm: 168 };

// Keep recording status banners above the chat launcher when it is available.
export const offsetForProjectChat = (bottom, chatAvailable) => ({
  xs: bottom.xs + (chatAvailable ? 64 : 0),
  sm: bottom.sm + (chatAvailable ? 72 : 0),
});
